export const MIN_PHONE_NUMBER_LENGTH = 10;
export const MAX_PHONE_NUMBER_LENGTH = 12;
export const PHONE_CODES = {
  INDIA: "91",
};
